import Swal from "sweetalert2";

export function showKeycloakUnavailableAlert(t) {
  return Swal.fire({
    icon: "warning",
    title: t(
      "publicWebsite.authUnavailableTitle",
      "Authentication unavailable"
    ),
    text: t(
      "publicWebsite.authUnavailableText",
      "Keycloak is still unavailable. Please wait a moment and try again."
    ),
    confirmButtonText: t("common.accept", "Accept"),
  });
}
